import styled from '@emotion/styled';

import { pageSectionLayout } from '@/styles/pageLayout';

export const IntroduceOwnerContainer = styled.article`
	${pageSectionLayout}
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 4rem;
`;
export const OwnerImage = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4rem;
	max-width: 40rem;
	width: 100%;
	img {
		width: 100%;
	}
`;
export const OwnerContentBox = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 3.2rem;
`;
export const OwnerTitleBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2rem;
	font-size: ${(props) => props.theme.fontSize.sizeLg};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
`;
export const OwnerTitle = styled.h5`
	font-size: ${(props) => props.theme.fontSize.size4xl};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: ${(props) => props.theme.ui.lineHeight.heading};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.tight};
	@media screen and (max-width: 900px) {
		font-size: ${(props) => props.theme.fontSize.size3xl};
	}
`;
export const OwnerContentMenuBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1.6rem;
`;
export const OwnerDescription = styled.p`
	font-size: ${(props) => props.theme.fontSize.sizeLg};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: ${(props) => props.theme.ui.lineHeight.body};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.body};
`;
export const OwnerSubTitle = styled.span`
	font-size: ${(props) => props.theme.fontSize.sizeLg};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: ${(props) => props.theme.ui.lineHeight.body};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.body};
`;
export const OwnerSign = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.8rem;
	width: 100%;
	align-items: flex-end;
`;
export const OwnerNameBox = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 2rem;
`;
export const OwnerName = styled.div`
	font-size: ${(props) => props.theme.fontSize.sizeLg};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: ${(props) => props.theme.ui.lineHeight.ui};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.body};
	display: flex;
	gap: 0.8rem;
	align-items: baseline;
	strong {
		font-size: ${(props) => props.theme.fontSize.size5xl};
		font-weight: ${(props) => props.theme.fontWeight.weightSemi};
		line-height: ${(props) => props.theme.ui.lineHeight.heading};
		letter-spacing: ${(props) => props.theme.ui.letterSpacing.tight};
	}
`;
